(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.galerieSwiper = {
    attach: function (context, settings) {
      once("galerieSwiper", ".paragraph--galerie .swiper-container", context).forEach(function (element) {
        var that = $(element);
        new Swiper($(element)[0], {
          loop: true,
          navigation: {
            nextEl: that.find(".swiper-button-next")[0],
            prevEl: that.find(".swiper-button-prev")[0],
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
